/**
 * Custom hook for navigation state management
 * Provides easy access to navigation Redux state and actions
 */
import { useSelector, useDispatch } from 'react-redux';
import {
  toggleItem,
  setItemState,
  selectItemsStates,
  selectIndicatorsWithStatus,
  selectCurrentEntityId,
  selectItemState,
} from '../../store/slices/navigationSlice.js';

/**
 * Hook for navigation state management
 * @returns {Object} Navigation state and actions
 */
const useNavigationState = () => {
  const dispatch = useDispatch();

  // Selectors
  const itemsStates = useSelector(selectItemsStates);
  const indicatorsWithStatus = useSelector(selectIndicatorsWithStatus);
  const currentEntityId = useSelector(selectCurrentEntityId);

  // Actions
  const handleToggleItem = (itemKey) => {
    dispatch(toggleItem(itemKey));
  };

  const handleSetItemState = (itemKey, value) => {
    dispatch(setItemState({ itemKey, value }));
  };

  // Utility to get specific item state
  const getItemState = (itemKey) => useSelector(selectItemState(itemKey));

  return {
    // State
    itemsStates,
    indicatorsWithStatus,
    currentEntityId,

    // Actions
    toggleItem: handleToggleItem,
    setItemState: handleSetItemState,
    getItemState,
  };
};

export default useNavigationState;